import { useEffect, useLayoutEffect } from 'react';
import './Resizeable.scss';

export interface ResizeableProps {
    left: React.ReactNode;
    right: React.ReactNode;
    min?: number;
}

export const Resizeable = (props: ResizeableProps) => {

    useEffect(() => {
        // Javascript implementation from https://stackoverflow.com/a/46934825
        
        var handler = document.querySelector('.handler');
        var wrapper = handler?.closest('.wrapper');
        var leftBox = wrapper?.querySelector('.box-left');
        var rightBox = wrapper?.querySelector('.box-right');
        var isHandlerDragging = false;

        (leftBox as any).style.width = '50%';
        (rightBox as any).style.width = '50%';

        function mouseDownListener(e: MouseEvent) {
            // If mousedown event is fired from .handler, toggle flag to true
            if (e.target === handler) {
                isHandlerDragging = true;
            }
        }

        function mouseMoveListener(e: MouseEvent) {
            // Don't do anything if dragging flag is false
            if (!isHandlerDragging) {
                return false;
            }

            // Get offset
            const containerOffsetLeft = (wrapper as any)?.offsetLeft;

            // Get x-coordinate of pointer relative to container
            const pointerRelativeXpos = e.clientX - containerOffsetLeft;
            const box2Width = document.documentElement.clientWidth - e.clientX;

            // Arbitrary minimum width set on box A, otherwise its inner content will collapse to width of 0
            const boxAminWidth = props.min ?? 200;
            const maxWidth =  document.documentElement.clientWidth - boxAminWidth - containerOffsetLeft - 20;

            const leftWidth = pointerRelativeXpos - 8;
            const rightWidth = box2Width - 20;

            let relativeLeftWidth = Math.max(boxAminWidth, leftWidth);
            let relativeRightWidth = Math.max(boxAminWidth, rightWidth);

            if (rightWidth < boxAminWidth) {
                relativeLeftWidth = maxWidth;
            } else if (leftWidth < boxAminWidth) {
                relativeRightWidth = maxWidth;
            }

            // Resize box A
            // * 8px is the left/right spacing between .handler and its inner pseudo-element
            // * Set flex-grow to 0 to prevent it from growing
            (leftBox as any).style.width = relativeLeftWidth + 'px';
            (leftBox as any).style.flexGrow = 0;

            (rightBox as any).style.width = relativeRightWidth + 'px';
            (rightBox as any).style.flexGrow = 0;
        }

        function mouseUpListener(e: MouseEvent) {
            // Turn off dragging flag when user mouse is up
            isHandlerDragging = false;
        }

        document.addEventListener('mousedown', mouseDownListener);
        document.addEventListener('mousemove', mouseMoveListener);
        document.addEventListener('mouseup', mouseUpListener);

        return () => {
            document.removeEventListener('mousedown', mouseDownListener);
            document.removeEventListener('mousemove', mouseMoveListener);
            document.removeEventListener('mouseup', mouseUpListener);
        };
    });

    return (
        <div className="wrapper">
            <div className="box-left">{props.left}</div>
            <div className="handler"></div>
            <div className="box-right">{props.right}</div>
        </div>
    );

}